import { render, staticRenderFns } from "./AtlasSetup.vue?vue&type=template&id=1f9efeea&scoped=true"
import script from "./AtlasSetup.vue?vue&type=script&lang=ts"
export * from "./AtlasSetup.vue?vue&type=script&lang=ts"
import style0 from "./AtlasSetup.vue?vue&type=style&index=0&id=1f9efeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9efeea",
  null
  
)

export default component.exports